import { MemberType } from "../../../types";
export const members: MemberType[] = [
    {
        name: "TPL Muibi Saheed Ololade",
        title: "Mr",
        id: 2,
        role: "Legal Practitioner",
        phone: "+23491211133",
        email: "hello@ourproperty.ng",
        image: "/images/review-image-1.webp",
    },
    {
        name: "ESV Bola Olakusibikan",
        title: "Mr",
        id: 2,
        role: "Account Officer",
        phone: "+23491211133",
        email: "hello@ourproperty.ng",
        image: "/images/review-image-2.webp",
    },
    {
        name: "Dr Rachael Bamigbade",
        title: "Mr",
        id: 2,
        role: "Staff",
        phone: "+23491211133",
        email: "hello@ourproperty.ng",
        image: "/images/review-image-3.webp",
    },
    {
        name: "Mr Usman Adekunle",
        title: "Mr",
        id: 2,
        role: "Account Officer",
        phone: "+23491211133",
        email: "hello@ourproperty.ng",
        image: "/images/review-image-4.webp",
    },
    {
        name: "Esq Fatima Abdulmaliq",
        title: "Mr",
        id: 2,
        role: "Staff",
        phone: "+23491211133",
        email: "hello@ourproperty.ng",
        image: "/images/review-image-5.webp",
    },
    {
        name: "Barrister Funke Ajala",
        title: "Mr",
        id: 2,
        role: "Account Officer",
        phone: "+23491211133",
        email: "hello@ourproperty.ng",
        image: "/images/review-image-6.webp",
    },
    {
        name: "Mr Sunday Ojulari",
        title: "Mr",
        id: 2,
        role: "Staff",
        phone: "+23491211133",
        email: "hello@ourproperty.ng",
        image: "/images/review-image-7.webp",
    },
    {
        name: "Mr Onos Chukundi",
        role: "Account Officer",
        title: "Mr",
        id: 2,
        phone: "+23491211133",
        email: "hello@ourproperty.ng",
        image: "/images/review-image-8.webp",
    },
];

export interface ProfileSummary {
    title?: string;
    second?: boolean;
    variant?: boolean;
    recent?: boolean;
    noHeader?: boolean;
    values?: Record<string, number | string>; // Allows any key-value pair
}
export interface BranchSummary extends ProfileSummary {
    // Allows any key-value pair
    members?: MemberType[];
}
export interface Branch {
    id: number;
    coverImage: string;
    address: string;
    branchName: string;
    aboutBranch: string; // Contains HTML as a string (e.g., <p> tags)
    branchSummary?: BranchSummary;
}

export const mockBranchData: Branch = {
    id: 3,
    coverImage: "/images/post-image.webp", // Replace with real URL
    address: "123 Real Estate Ave, Lagos, Nigeria",
    branchName: "Lagos Mainland Branch",
    aboutBranch: `
  <p>Our Lagos Mainland branch serves as the hub for all real estate transactions in the region, offering a wide range of property management services, from rentals to sales and short-term leasing. Strategically located, it provides easy access to both residential and commercial properties, ensuring that clients find their perfect home or investment with minimal hassle.</p> 
  <p>With over a decade of experience in the real estate sector, our dedicated team of professionals works tirelessly to provide top-notch property management, legal advisory, and seamless transaction services. Whether you are a first-time buyer, a seasoned investor, or a business looking for commercial space, our branch is equipped to meet all your real estate needs.</p> 
  
  <p>At our Lagos Mainland branch, we take pride in our commitment to customer satisfaction. Our team is always ready to guide you through the entire process, ensuring transparency, efficiency, and convenience. From property listings to finalizing deals, we leverage cutting-edge technology and deep market knowledge to provide the best solutions tailored to your needs.</p> 
  
  <p>We also offer consultancy services, helping clients navigate the complexities of property ownership, mortgage financing, and legal documentation. Our mission is to simplify real estate transactions while upholding the highest industry standards. Trust us to make your property journey smooth, secure, and rewarding.</p>
`,
    branchSummary: {
        title: "Branch Summary",
        values: {
            total_staff: 120,
            property_for_rent: 200,
            property_for_sale: 150,
            property_for_short_let: 80,
            total_unit_managing: 300,
            total_reviews: 450,
            completed_transaction: 500,
        },
        members: members
    },
};

export default mockBranchData

